{
  "page": {
    "fallbackTitle": "My Team",
    "managerLabel": "Manager: {name}",
    "ridersCount": "{count}/{cap} senior riders",
    "youthSquadCounts": "+{u23} U23 · +{junior} juniors",
    "seniorCapTooltip": "Squad cap is {cap} senior riders. Academy riders don't count toward it.",
    "youthSquadCountsTooltip": "U23 and junior riders have their own squad caps (12 and 10) and do not count toward the senior cap.",
    "incomingCount": "+{count} incoming",
    "outgoingCount": "-{count} outgoing",
    "salaryPerSeason": "Salary/season: {value} CZ$",
    "salaryPerSeasonTooltip": "Total salary your squad earns per season",
    "teamValue": "Team value: {value} CZ$",
    "division": "Division {n}",
    "divisionTooltip": "Your league tier. Division 1 is the top tier, Division 4 the entry tier.",
    "balance": "{value} CZ$",
    "balanceTooltip": "CZ$ is the in-game currency. You earn it by playing, and it cannot be bought with real money.",
    "ownAuctionsBanner": "{count, plural, one {# of your riders is up for auction} other {# of your riders are up for auction}} · view auctions"
  },
  "promotionPending": {
    "title": "Awaiting promotion",
    "hint": "Their next squad is full. They keep racing in their current squad on the same contract.",
    "waitingFor": {
      "u23": "Waiting for a U23 spot",
      "senior": "Waiting for a senior spot"
    },
    "promote": "Promote",
    "noRoom": "No spot yet",
    "promoted": "{name} moved up.",
    "error": {
      "squad_full": "That squad is full. Free a spot first.",
      "rider_on_market": "He is up for auction. Promote him when the auction ends.",
      "rider_in_stage_race": "He is in a stage race. Promote him when it is over.",
      "generic": "Could not promote the rider. Try again."
    }
  },
  "tabs": {
    "ariaLabel": "Team sections",
    "squad": "Squad ({count})",
    "development": "Development",
    "stats": "Stats",
    "transfers": "Transfer history",
    "contracts": "Contracts"
  },
  "development": {
    "headers": {
      "projected": "Projected",
      "projectedTitle": "Projected rating range for his primary role, based on your training. Sorted on the upper bound.",
      "ceiling": "Ceiling",
      "ceilingTitle": "The theoretical highest rating his role could reach. Not adjusted for how you train him."
    },
    "noForecast": "No forecast yet"
  },
  "stats": {
    "seasonLabel": "Season {n}",
    "noActiveSeason": "No active season right now.",
    "loadError": "Could not load season stats. Please try again.",
    "retry": "Try again",
    "headers": {
      "raceDays": "Race days",
      "wins": "Wins",
      "points": "Points",
      "prize": "Prize money"
    }
  },
  "squad": {
    "view": {
      "ariaLabel": "Squad view",
      "current": "Current squad ({count})",
      "upcoming": "Next season ({count})",
      "upcomingHint": "Shows the squad once pending transfers are completed."
    },
    "filter": {
      "label": "Show",
      "seniors": "Seniors ({count})",
      "academy": "Academy ({count})"
    },
    "emptyState": "Your squad is empty",
    "emptyStateBody": "Sign your first riders from the market to start building your team.",
    "emptyStateCta": "Browse riders",
    "emptyStateCtaAuctions": "Go to auctions",
    "emptyView": "No riders match the current view.",
    "headers": {
      "nation": "Nation",
      "rider": "Rider",
      "rating": "Rating",
      "ratingTitle": "The weighted average of the abilities his own role needs. The same number means the same level in any role.",
      "value": "Value",
      "salary": "Salary",
      "potential": "Potential",
      "potentialTitle": "The projected rating range he's realistically heading toward with your training. Not the same as the role's ceiling (the theoretical highest for his role) - hover the number for both.",
      "badges": "Status",
      "age": "Age",
      "popularity": "Popularity",
      "popularityTitle": "Fan popularity (0-100). Used by the board's 5-year plan star-rider goal.",
      "reputationLabel": "Reputation",
      "reputationTitle": "Earned race reputation. This is the number the board reads for profile riders.",
      "contract": "Contract",
      "contractUntil": "Until season {season}",
      "contractExpired": "Expired",
      "action": "Action"
    },
    "reputation": {
      "band": {
        "unknown": "Unknown",
        "known": "Known",
        "profile": "Profile",
        "star": "Star",
        "legend": "Legend"
      }
    },
    "mode": {
      "ariaLabel": "Table columns",
      "overview": "Overview",
      "abilities": "Abilities"
    },
    "count": "{count, plural, one {1 rider} other {# riders}}",
    "actionButton": "Sell / Auction",
    "ownAuctionTooltip": "In auction · highest bid {price} CZ$ · ends in {timeLeft}",
    "ownTransferListingTooltip": "Listed for transfer · asking {price} CZ$"
  },
  "actionModal": {
    "potentialLabel": "Potential",
    "tabs": {
      "auction": "Auction",
      "transfer": "Transfer list",
      "release": "Release",
      "extend": "Extend contract",
      "move": "Move squad"
    },
    "auction": {
      "description": "Start auction. Other managers can bid.",
      "startButton": "Start",
      "startFlashButton": "Start Flash",
      "flashLabel": "Flash auction (30 min)",
      "flashHint": "Deadline Day: ends exactly 30 minutes after start",
      "successMsg": "Auction started!",
      "priceError": "Start price must be between 0 and Value ({amount} CZ$)",
      "endLabel": "Auction ends",
      "endHint": "{min}-{max} hours from now, game time (Copenhagen).",
      "endWindowHint": "The market is open {open}-{close}."
    },
    "transfer": {
      "description": "List for sale at a fixed price.",
      "listButton": "List for sale",
      "successMsg": "Listed for sale!"
    },
    "release": {
      "description": "Terminate this rider's contract and let them go as a free agent.",
      "feeLabel": "Buyout fee",
      "balanceLabel": "Your balance",
      "feeHint": "Half a season's salary for each remaining contract season.",
      "freeHint": "This rider has no salary, so the release is free.",
      "confirmButton": "Release rider",
      "cannotAfford": "You can't afford the buyout fee.",
      "successMsg": "Rider released."
    },
    "extend": {
      "description": "Extend the contract by one season. The salary is renegotiated from the rider's current value.",
      "currentSalaryLabel": "Current salary",
      "newSalaryLabel": "New salary",
      "newContractLabel": "New contract",
      "newContractValue": "Expires after S{season}",
      "confirmButton": "Extend contract",
      "loadingTermsButton": "Loading terms…",
      "workingButton": "Extending…",
      "successMsg": "Contract extended.",
      "capped": "Contract at maximum length (through season {season}).",
      "capCounterLabel": "Extensions used"
    },
    "move": {
      "description": "Move this rider to the senior squad, U23 team or junior team. You pick the squad and see the full effect next.",
      "openButton": "Choose squad"
    },
    "loadingShort": "...",
    "errorPrefix": ""
  },
  "profile": {
    "back": "Back",
    "notFound": "Team not found",
    "loadError": {
      "message": "Couldn't load the team. Nothing was lost. Try again.",
      "retry": "Try again"
    },
    "tabsAriaLabel": "Team profile sections",
    "yourTeam": "Your team",
    "managerLabel": "Manager: {name}",
    "division": "Division {n}",
    "statRidersNow": "Riders now",
    "statIncoming": "Incoming",
    "statOutgoing": "Outgoing",
    "statTeamValue": "Team value",
    "seasonResults": "Season results",
    "seasonLabel": "Season {n}",
    "seasonOngoing": "Ongoing",
    "seasonFinished": "Finished",
    "seasonPoints": "Points",
    "seasonStageWins": "Stage wins",
    "seasonGcWins": "GC wins",
    "tabSquad": "Squad ({count})",
    "tabResults": "Results",
    "tabPalmares": "Palmarès",
    "tabTransfers": "Transfer history",
    "tabClub": "Staff & Facilities",
    "squadTitle": "Squad ({count} riders)",
    "viewCurrent": "Current squad ({count})",
    "viewUpcoming": "Next season ({count})",
    "viewUpcomingHint": "Shows the squad once pending transfers are completed.",
    "noRiders": "No riders",
    "thNation": "Nation",
    "thRider": "Rider",
    "thBadges": "Status",
    "thAge": "Age",
    "thValue": "Value",
    "palmares": {
      "totalsTitle": "Career totals",
      "totals": {
        "seasons": "Seasons",
        "wins": "Wins",
        "bestResult": "Best result",
        "honours": "Hall of Fame",
        "bestResultValue": "Division {division} · #{rank}"
      },
      "seasonHistoryTitle": "Season by season",
      "thSeason": "Season",
      "thDivision": "Division",
      "thRank": "Rank",
      "thPoints": "Points",
      "thWins": "Wins",
      "movementPromoted": "Promoted",
      "movementRelegated": "Relegated",
      "honoursTitle": "Hall of Fame",
      "honoursEmpty": "No Hall of Fame entries yet for this team.",
      "emptyTitle": "No palmarès yet",
      "emptyBody": "Every season played writes a new line here.",
      "loadError": "Palmarès could not be loaded right now."
    }
  },
  "results": {
    "title": "Race results",
    "subtitle": "All race results for this team",
    "seasonFilterAll": "All seasons",
    "seasonFilterCurrent": "Season {n} (current)",
    "seasonOption": "Season {n}",
    "seasonRow": "Season {n}",
    "loadError": "Could not load the results. Please try again.",
    "emptyAll": "No race results yet",
    "emptyFiltered": "No results in the selected season",
    "thRace": "Race",
    "thType": "Classification",
    "thRank": "Rank",
    "thRider": "Rider",
    "thPoints": "Points",
    "thPrize": "Prize",
    "stageN": "Stage {n}",
    "riderTeam": "Team",
    "total": "Total · {count, plural, one {# result} other {# results}}",
    "type": {
      "stage": "Stage",
      "gc": "Overall (GC)",
      "oneday": "One-day result",
      "points": "Points classification",
      "mountain": "Mountains classification",
      "young": "Young rider",
      "team": "Team classification",
      "leader": "Leader jersey (day)",
      "points_day": "Points jersey (day)",
      "mountain_day": "Mountains jersey (day)",
      "young_day": "Youth jersey (day)"
    }
  },
  "club": {
    "facilitiesTitle": "Facilities",
    "staffTitle": "Staff",
    "noStaff": "No staff hired",
    "errorTitle": "Couldn't load this",
    "errorDescription": "Staff and facilities couldn't be loaded right now."
  },
  "manager": {
    "back": "Back",
    "notFound": "Team not found",
    "loadError": {
      "message": "Couldn't load this manager's profile. Nothing was lost. Try again.",
      "retry": "Try again"
    },
    "yourTeam": "Your team",
    "managerPrefix": "Manager:",
    "aiManaged": "AI-managed team",
    "division": "Division {n}",
    "settingsLink": "Settings",
    "streak": "streak",
    "achievements": "achievements",
    "recentlyUnlocked": "Recently unlocked",
    "noRecentAchievements": "Nothing unlocked yet. Race, bid and build a squad to start collecting.",
    "inProgress": "In progress",
    "progressTowards": "{title}: {current} of {target}",
    "tabOverview": "Overview",
    "tabRiders": "Team ({count})",
    "tabSeason": "Season history",
    "tabAchievements": "Achievements {unlocked}/{total}",
    "statSeasons": "Seasons",
    "statTransfers": "Transfers",
    "statForumPosts": "Forum posts",
    "recentTransfers": "Recent transfers",
    "noTransfers": "No transfers yet",
    "boughtFrom": "Bought from",
    "soldTo": "Sold to",
    "noRiders": "No riders",
    "noSeasonHistory": "No season history yet",
    "noAchievements": "No achievements yet",
    "seasonOngoing": "Ongoing",
    "thRider": "Rider",
    "thValue": "Value",
    "thSeason": "Season",
    "thDivision": "Division",
    "thPoints": "Points",
    "thRank": "Rank",
    "seasonNumber": "Season {n}",
    "divisionShort": "Div. {n}",
    "discordOpenAria": "Open {handle}'s Discord profile",
    "discordCopyAria": "Copy Discord username {handle}",
    "discordCopied": "Copied"
  },
  "contracts": {
    "headers": {
      "seasons": "Seasons",
      "salary": "Salary now / new",
      "newContract": "New contract"
    },
    "selectRider": "Select {name}",
    "selectGroup": "Select all: {group}",
    "seasonsFor": "Seasons to extend {name}",
    "seasonsCount": "{count}",
    "seasonsMax": "{count} (max)",
    "noContract": "No contract",
    "group": {
      "expiring": "Expires this season",
      "season": "Expires after season {season}",
      "atCap": "At the limit",
      "atCapHint": "Already runs as far as allowed. Can be extended again when the season changes."
    },
    "bar": {
      "none": "Tick the riders you want to extend.",
      "selected": "{count, plural, one {# rider selected} other {# riders selected}}",
      "salaryDelta": "Salary {value} CZ$ per season",
      "seasonsLabel": "Seasons",
      "extend": "{count, plural, =0 {Extend contracts} one {Extend # contract} other {Extend # contracts}}"
    },
    "summary": {
      "title": "Extend contracts",
      "cancel": "Cancel",
      "confirm": "{count, plural, one {Extend # contract} other {Extend # contracts}}",
      "loadError": "Couldn't load the summary. Nothing was changed.",
      "saveError": "Couldn't extend the contracts. Nothing was changed.",
      "teamSalary": "Team salary per season",
      "salaryCap": "Board salary cap",
      "noCap": "No cap set",
      "withinCap": "Within the cap",
      "overCap": "Over the cap of {cap} CZ$. Nothing will be extended"
    },
    "done": "{count, plural, one {# contract extended.} other {# contracts extended.}}",
    "loadErrorTitle": "Couldn't load your contracts",
    "loadErrorBody": "Nothing was lost. Your contracts are unchanged.",
    "retry": "Try again",
    "emptyTitle": "Sign riders to manage their contracts",
    "emptyBody": "Riders you own show up here, grouped by when their contract expires."
  }
}
